import React from 'react';

import styles from './ThingsToKnow.module.css';

const ThingsToKnow = ({ text, cityName, title }) => {
  return (
    <div style={{ paddingTop: '15px' }}>
      <h2 className={'desktopShow'}>{`${title} ${cityName}`}</h2>

      <h2
        style={{ display: 'none' }} // disabled in SSR HTML
        className="mobileShow paddingR16"
      >
        <span
          style={{ display: 'block' }}
          className={'font22 latoLight appendBottom2'}
        >
          {title}
        </span>
        <span className={'font16 latoBold lineHeight20 blackText'}>
          {cityName}
        </span>
      </h2>
      <div className={styles.thingsToKnowWarp}>
        <div
          className={`${styles.thingsToKnowText}  appendBottom20`}
          dangerouslySetInnerHTML={{ __html: text }}
        ></div>
      </div>
    </div>
  );
};

export default ThingsToKnow;
